module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    attrs: {
      "id": "page__document"
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  })], 1), _vm._v(" "), (_vm.document && _vm.document.id) ? _c('doc', {
    attrs: {
      "document": _vm.document,
      "deal": _vm.document.deal
    },
    on: {
      "refresh-doc": _vm.getDocument
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53f70753","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/deals/views/Document.vue
// module id = 1146
// module chunks = 0